export default __webpack_public_path__ + "static/media/learose5-1920w.031d3345.webp";